import { useEffect, useState } from 'react';
import { getAvailableVoices, type TTSVoice } from '@/services/audioService';

let catalog: Promise<Map<string, TTSVoice>> | null = null;

/** The studio's voice list (GET /api/audio/voices), fetched once per page: voice id → voice. Null until it arrives. */
export function useVoiceCatalog(): Map<string, TTSVoice> | null {
  const [voices, setVoices] = useState<Map<string, TTSVoice> | null>(null);
  useEffect(() => {
    let live = true;
    catalog ??= getAvailableVoices().then((r) => new Map(r.voices.map((v) => [v.id, v])));
    catalog.then(
      (m) => { if (live) setVoices(m); },
      () => { catalog = null; },
    );
    return () => { live = false; };
  }, []);
  return voices;
}

/**
 * The line a picker shows under a voice: the start of Google's description ("Firm, direct, and authoritative voice
 * with a medium pitch…" → "Firm, direct, and authoritative"). v1's `description` is frozen for Kubicle and
 * contradicts Google's for several voices (Kore "Warm, friendly"), so the studio never shows it.
 */
export function voiceLine(voice: Pick<TTSVoice, 'summary'>): string {
  return /^(.+?)\s+voice\b/i.exec(voice.summary)?.[1] ?? voice.summary;
}
